export default "__VITE_ASSET__BARDu3xx__"